import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AdminLayout from '../admin-layouts/AdminLayout';
import DealListPage from '../features/deals/DealListPage';
import DealDetailPage from '../features/deals/DealDetailPage';
import DealSubmitPage from '../features/deals/DealSubmitPage';
import DealEditPage from '../features/deals/DealEditPage';
import LoginPage from '../features/auth/LoginPage';
import RegisterPage from '../features/auth/RegisterPage';
import ForgotPasswordPage from '../features/auth/ForgotPasswordPage';
import ResetPasswordPage from '../features/auth/ResetPasswordPage';
import VerifyEmailPage from '../features/auth/VerifyEmailPage';
import AlertsPage from '../features/alerts/AlertsPage';
import NotificationsPage from '../features/notifications/NotificationsPage';
import NotificationPreferencesPage from '../features/notifications/NotificationPreferencesPage';
import ProfilePage from '../features/profile/ProfilePage';
import SearchPage from '../features/search/SearchPage';
import AuthGuard from '../components/AuthGuard';
import AdminDashboardPage from '../admin/DashboardPage';
import AdminModerationPage from '../admin/ModerationPage';
import AdminDealsPage from '../admin/DealsPage';
import AdminDealEditPage from '../admin/DealEditPage';
import AdminMerchantsPage from '../admin/MerchantsPage';
import AdminCategoriesPage from '../admin/CategoriesPage';
import AdminUsersPage from '../admin/UsersPage';
import AdminFeatureFlagsPage from '../admin/FeatureFlagsPage';
import AdminAffiliateProgramsPage from '../admin/AffiliateProgramsPage';
import AdminAuditLogsPage from '../admin/AuditLogsPage';
import AdminAnalyticsPage from '../admin/AnalyticsPage';
import AdminSettingsPage from '../admin/SettingsPage';
import AdminNotificationsPage from '../admin/NotificationsPage';

export default function Router() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      <Route element={<MainLayout />}>
        <Route path="/" element={<DealListPage />} />
        <Route
          path="/deals/submit"
          element={<AuthGuard><DealSubmitPage /></AuthGuard>}
        />
        <Route
          path="/deals/:publicId/edit"
          element={<AuthGuard><DealEditPage /></AuthGuard>}
        />
        <Route path="/deals/:publicId" element={<DealDetailPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route
          path="/alerts"
          element={<AuthGuard><AlertsPage /></AuthGuard>}
        />
        <Route
          path="/notifications"
          element={<AuthGuard><NotificationsPage /></AuthGuard>}
        />
        <Route
          path="/settings/notifications"
          element={<AuthGuard><NotificationPreferencesPage /></AuthGuard>}
        />
        <Route
          path="/profile"
          element={<AuthGuard><ProfilePage /></AuthGuard>}
        />
        <Route
          path="/profile/:publicId"
          element={<ProfilePage />}
        />
      </Route>

      <Route path="/admin" element={<AuthGuard requireRole={['admin', 'moderator']}><AdminLayout /></AuthGuard>}>
        <Route index element={<AdminDashboardPage />} />
        <Route path="moderation" element={<AdminModerationPage />} />
        <Route path="deals" element={<AdminDealsPage />} />
        <Route path="deals/:publicId/edit" element={<AdminDealEditPage />} />
        <Route path="merchants" element={<AdminMerchantsPage />} />
        <Route path="categories" element={<AdminCategoriesPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="feature-flags" element={<AdminFeatureFlagsPage />} />
        <Route path="affiliate-programs" element={<AdminAffiliateProgramsPage />} />
        <Route path="notifications" element={<AdminNotificationsPage />} />
        <Route path="audit-logs" element={<AdminAuditLogsPage />} />
        <Route path="analytics" element={<AdminAnalyticsPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
      </Route>
    </Routes>
  );
}
